export const esquemaNovedad = [
  {
    name: 'numeroDocumento',
    type: 'Integer',
    required: true,
    maxlength: 15,
    min: 0,
  },
  { name: 'tipoNovedad', type: 'Enum', required: true },
  { name: 'fechaInicio', type: 'Date', required: true },
  { name: 'fechaFin', type: 'Date', required: true },
  {
    name: 'observacion',
    type: 'String',
    required: true,
    maxlength: 255,
  },
];
